export default __webpack_public_path__ + "static/media/DinosaursCarnivores_03.7a9168aa.png";